import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 203 326",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M37 245.224C37 255.331 44.2196 262.551 55.7711 262.551H145.872C157.712 262.551 164.355 255.62 164.355 245.513C164.355 235.116 157.712 228.185 145.872 228.185H90.7141V227.608L142.407 166.674C154.536 152.235 162.333 137.796 162.333 119.024C162.333 87.258 139.23 63 101.977 63C67.0337 63 45.086 82.6374 40.7542 103.719C40.4654 105.452 40.1766 107.184 40.1766 108.628C40.1766 119.313 47.9739 126.533 58.3701 126.533C66.4561 126.533 72.5206 121.912 76.5636 113.538C81.7618 102.852 88.9814 97.0767 100.244 97.0767C114.106 97.0767 121.903 106.607 121.903 119.602C121.903 129.71 117.86 137.796 110.352 146.748L49.129 220.099C40.1766 230.785 37 236.849 37 245.224Z",
      fill: "#E5E5E5"
    }, null, -1)
  ])))
}
export default { render: render }